// @flow

import invariant from 'invariant';

import moment from 'moment';
const { duration } = moment;

import { durationHumanize } from 'duration-humanize';

const ZERO_PRETTY_REPR = '0 секунд';

export const durationPrettyRepr = (v: mixed): string => {
	if (!v || (typeof v !== 'number' && typeof v !== 'object')) {
		return ZERO_PRETTY_REPR;
	}

	const d: duration = moment.isDuration(v)
		  ? (v: any)
		  : duration(v);

	invariant(
		typeof d.isValid === 'function',
		'`duration.isValid` must be defined, see momentjs docs'
	);

	return d.isValid()
		? durationHumanize(d) || ZERO_PRETTY_REPR
		: ZERO_PRETTY_REPR;
};

export const durationPrettyReprExtend = { repr: {
	durationPretty: durationPrettyRepr,
	default: durationPrettyRepr,
} };
